import styled from "styled-components";

const PrimaryButton = styled.button`
  align-items: center;
  background: var(--terbine-blue);
  border-radius: 8px;
  color: white;
  cursor: pointer;
  display: flex;
  flex-direction: column;
  font-family: Inter, Oxygen, Roboto, sans-serif;
  font-size: 16px;
  gap: 0px;
  justify-content: center;
  line-height: 24px;
  padding: 12px;
  position: relative;
  text-align: left;
  width: 240px;
`;

export default PrimaryButton;
